import { render, staticRenderFns } from "./AnexosUnique.vue?vue&type=template&id=3bcec7a2&scoped=true&"
import script from "./AnexosUnique.vue?vue&type=script&lang=js&"
export * from "./AnexosUnique.vue?vue&type=script&lang=js&"
import style0 from "./AnexosUnique.vue?vue&type=style&index=0&id=3bcec7a2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bcec7a2",
  null
  
)

export default component.exports